import { EditableText } from "@repo/ui/Inputs/editableText";
import type { FC } from "react";

interface ProjectNameEditorProps {
  name: string;
  onChange: (name: string) => Promise<void> | void;
  isDisabled?: boolean;
  /**
   * By default the name renders as its own `h2` page title. Hosts that place
   * the editor inside their own heading pass `false` so the markup stays valid.
   */
  renderAsHeading?: boolean;
}

export const ProjectNameEditor: FC<ProjectNameEditorProps> = (props) => {
  const { name, onChange, isDisabled, renderAsHeading = true } = props;
  const Wrapper = renderAsHeading ? "h2" : "span";

  return (
    <Wrapper className={renderAsHeading ? "block h-9" : "inline-block h-9"}>
      <EditableText
        accessibleLabel="Project name"
        className="inline-flex w-auto max-w-[22rem]"
        editAccessibleLabel="Edit project name"
        inputClassName="h-9 py-1.5 text-xl leading-7 font-semibold [&:not(:read-only)]:w-80"
        isDisabled={isDisabled}
        maxLength={150}
        minLength={2}
        onSave={onChange}
        value={name}
      />
    </Wrapper>
  );
};
